//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var BASE_URL = '/prototype/accounting/accounts-receivable/reports';
import { createExport } from '@/mixins/createExport';

export default {
    mixins: [createExport],
    data: function data() {
        return {
            start_date: moment().subtract(1, 'months').format("MM/DD/YYYY"),
            end_date: moment().format("MM/DD/YYYY"),
            accounts: [{ value: 'All', label: 'All Accounts' }],
            selectedAccount: { value: null, label: 'All Accounts' },
            headers: ['Unit', 'Resident', 'Move Out', { title: 'Period', filter: 'datePeriod' }, { title: 'Date', filter: 'dateFull' }, { title: 'Due Date', filter: 'dateFull' }, 'Reference', 'G/L Account', 'G/L Name', 'Charge Code', { title: 'Credit', filter: 'toCurrency' }, { title: 'Charge', filter: 'toCurrency' }],
            fields: ['Unit', 'Resident', 'MoveOut', 'Period', 'Date', 'Due', 'Reference', 'Account', 'Name', 'Code', 'Credit', 'Charge'],
            items: [],
            loading: true,
            filterKey: ''
        };
    },
    created: function created() {
        var _this = this;

        Event.$on('accrual-income-report', function () {
            _this.$children[0].showModal = true;
            _this.load();
        });

        Event.$on('exportAccrualIncomeToExcel', function () {
            return _this.exportToExcel();
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('accrual-income-report');
        Event.$off('exportAccrualIncomeToExcel');
    },

    methods: {
        exportToExcel: function exportToExcel() {
            this.loading = true;

            var data = {
                start_date: this.start_date,
                end_date: this.end_date,
                gl_account: this.selectedAccount !== "All" ? this.selectedAccount.value : null,
                exportExcel: true
            };

            this.createExport(data, BASE_URL + '/accrual-income', 'accrual-income', '.xlsx');

            this.loading = false;
        },
        applyFilter: function applyFilter() {
            this.load();
        },
        load: function load() {
            var _this2 = this;

            this.loading = true;

            // build payload
            var data = {
                start_date: this.start_date,
                end_date: this.end_date,
                gl_account: this.selectedAccount != "All" ? this.selectedAccount.value : null
            };

            axios.post(BASE_URL + '/accrual-income', data).then(function (response) {
                _this2.items = response.data;
                _this2.items.map(function (item) {
                    if (item.Account) {
                        if (!_this2.accounts.find(function (elem) {
                            return elem.value == item.Account;
                        })) {
                            _this2.accounts.push({ value: item.Account, label: item.Account + ' | ' + item.Code });
                        }
                    }
                });
                _this2.loading = false;
            });
        },
        sortBy: function sortBy(key) {
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;
        }
    },

    computed: {
        totalCredits: function totalCredits() {
            return Number.parseFloat(this.items.reduce(function (prev, cur) {
                return Number.parseFloat(prev) + Number.parseFloat(cur.Credit);
            }, 0)).toFixed(2);
        },
        totalCharges: function totalCharges() {
            return Number.parseFloat(this.items.reduce(function (prev, cur) {
                return Number.parseFloat(prev) + Number.parseFloat(cur.Charge);
            }, 0)).toFixed(2);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/accounts-receivable/reports/AccrualIncomeReport.vue
// module id = 0lK+
// module chunks = 0 1